module.exports = __webpack_public_path__ + "static/media/indexProgressIcon.a90fe289.svg";